import React from 'react';

import cx from 'classnames';

import LandingPage from 'components/shared/LandingPage';
import LandingPagesContainer from 'components/shared/LandingPage/components/Grid';
import LandingPageContext from 'components/shared/LandingPage/contexts/LandingPageContext';

import { useLandingContext } from './functions';
import s from './index.module.css';

function Preview({ initialAnchorSection, containerClassName, ...props }) {
  const contextValue = useLandingContext(props);

  return (
    <LandingPageContext.Provider value={contextValue}>
      <LandingPagesContainer className={cx(s.landingPagesContainer, containerClassName)}>
        <LandingPage
          initialAnchorSection={initialAnchorSection}
          landingPageType={props.page.type || props.landingData.type}
        />
      </LandingPagesContainer>
    </LandingPageContext.Provider>
  );
}

export default Preview;
